import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useI18n } from "@/i18n";
import { RichText } from "./RichText";

export function PhotoToggle() {
  const { t } = useI18n();
  const [active, setActive] = useState<"file" | "edited">("file");

  const items =
    active === "file"
      ? t.photoToggle.fileDeliveryDetails
      : t.photoToggle.editedPackageDetails;

  return (
    <div className="mt-4">
      {/* Toggle */}
      <div className="relative flex bg-surface-1 rounded-xl p-1">
        <motion.div
          className="absolute inset-y-1 rounded-lg bg-white shadow-soft"
          initial={false}
          animate={{
            left: active === "file" ? "4px" : "50%",
            right: active === "file" ? "50%" : "4px",
          }}
          transition={{ type: "spring", stiffness: 400, damping: 35 }}
        />
        <button
          onClick={() => setActive("file")}
          className={`relative z-10 flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 ${
            active === "file" ? "text-ink-0" : "text-ink-2"
          }`}
        >
          {t.photoToggle.fileDelivery}
        </button>
        <button
          onClick={() => setActive("edited")}
          className={`relative z-10 flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 ${
            active === "edited" ? "text-ink-0" : "text-ink-2"
          }`}
        >
          {t.photoToggle.editedPackage}
        </button>
      </div>

      {/* Content */}
      <div className="mt-4 min-h-[160px]">
        <AnimatePresence mode="wait">
          <motion.ul
            key={active}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="space-y-3"
          >
            {items.map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.06, duration: 0.3 }}
                className="flex gap-3 text-sm text-ink-1 leading-relaxed"
              >
                <span className="flex-shrink-0 mt-1.5 w-1.5 h-1.5 rounded-full bg-kra-light" />
                <span><RichText text={item} /></span>
              </motion.li>
            ))}
          </motion.ul>
        </AnimatePresence>
      </div>
    </div>
  );
}
